export default __webpack_public_path__ + "static/media/moshed.8402053a.webm";